export default __webpack_public_path__ + "static/media/arrow.24e95959.svg";